export function SkeletonLine({ className = "" }) {
    return <div className={`skeleton h-4 ${className}`} />;
}

export function SkeletonCard() {
    return (
        <div className="rounded-lg border border-line bg-card p-5">
            <SkeletonLine className="w-1/3" />
            <div className="skeleton mt-3 h-8 w-2/3" />
            <SkeletonLine className="mt-3 w-1/2" />
        </div>
    );
}

export function SkeletonList({ rows = 5 }) {
    return (
        <div className="divide-y divide-line rounded-lg border border-line bg-card">
            {Array.from({ length: rows }).map((_, i) => (
                <div key={i} className="flex items-center gap-4 p-4">
                    <div className="skeleton h-10 w-10 rounded-lg" />
                    <div className="flex-1 space-y-2">
                        <SkeletonLine className="w-1/3" />
                        <SkeletonLine className="w-1/4" />
                    </div>
                </div>
            ))}
        </div>
    );
}
